// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__14e2g","ThumbZoom":"ChapterPlayer_ThumbZoom__1Fhiu"};